import React, {useEffect, useState} from 'react'
import DHDialog from "../../general/DHDialog";
import DHButtonSave from "../../general/DHButtonSave";
import ErrorInfoComponent from "../../general/ErrorInfoComponent";
import ConfigUtil from "../../../util/ConfigUtil";
import FetchUtil from "../../../util/FetchUtil";
import LigaVerwaltungFieldDescription from "./LigaVerwaltungFieldDescription";
import DHButtonDefault from "../../general/DHButtonDefault";
import DHTimePicker from "../../general/DHTimePicker";

export default function LigaMannschaftSettingsDialog({eventOperatorId, mannschaft, onRefresh, onClose}) {

    const [infoMessage, setInfoMessage] = useState(undefined);
    const [errorMessage, setErrorMessage] = useState(undefined);

    const [working, setWorking] = useState(false);

    const [id, setId] = useState(undefined);
    const [bezeichnung, setBezeichnung] = useState("");
    const [gameday, setGameday] = useState(undefined);
    const [gamezeitpunkt, setGamezeitpunkt] = useState(undefined);

    useEffect(() => {
        if( mannschaft ) {
            setId(mannschaft.id);
            setBezeichnung(mannschaft.bezeichnung);
            setGameday(mannschaft.gameday);
            setGamezeitpunkt(mannschaft.gamezeitpunkt);
        }
    }, [mannschaft]);

    const save = () => {
        setWorking(true);
        let data = {mannschaftId: id, gameday: gameday, gamezeitpunkt: gamezeitpunkt}
        let url = ConfigUtil.getConfig().resourceUrls.league + "/mannschaft/settings/save/" + eventOperatorId;
        FetchUtil.fetchPost(url,
            data,
            json => {
                setInfoMessage("Speichern erfolgreich...");
                onRefresh();
                setWorking(false);
            },
            responseNotOk => {
                setErrorMessage("Fehler: " + responseNotOk.message);
                setWorking(false);
            },
            error => {
                setErrorMessage("Fehler: " + error.message)
                setWorking(false);
            });
    }

    const isDisabled = () => {
        if(gameday || gamezeitpunkt) {
            return !gameday || !gamezeitpunkt
        }
        return false;
    }

    const getButtons = () => {
        return [<DHButtonSave onClick={() => save()} working={working} disabled={isDisabled()}/>];
    }


    const getWeekdaysArea = () => {
        return <div style={{marginTop:20}}>
            <LigaVerwaltungFieldDescription text={"Für die Liga wird ein Rahmenspielplan erstellt in dem z.B. Samstag 19 Uhr als Standardzeit für den Spieltag festgelegt wird."}/>
            <LigaVerwaltungFieldDescription text={"Sofern die Mannschaft davon abweichend z.B. immer Freitags um 20 Uhr spielen möchte, kannst du dies hier einstellen."}/>
            <LigaVerwaltungFieldDescription text={"Wichtig ist, das System versucht den Spieltag für diese Mannschaft dann auf diesen Tag zu legen. Dafür muss der entsprechende Tag im Rahmenspielplan innerhalb des Von- und Bisdatums möglich sein."}/>
            <div style={{marginTop:10}}>
                <DHButtonDefault label="Mo"
                                 style={{backgroundColor: gameday !== "mo" ? "grey" : "blue"}}
                                 onClick={() => setGameday("mo")}/>
                <DHButtonDefault label="Di"
                                 style={{backgroundColor: gameday !== "di" ? "grey" : "blue"}}
                                 onClick={() => setGameday("di")}/>
                <DHButtonDefault label="Mi"
                                 style={{backgroundColor: gameday !== "mi" ? "grey" : "blue"}}
                                 onClick={() => setGameday("mi")}/>
                <DHButtonDefault label="Do"
                                 style={{backgroundColor: gameday !== "do" ? "grey" : "blue"}}
                                 onClick={() => setGameday("do")}/>
                <DHButtonDefault label="Fr"
                                 style={{backgroundColor: gameday !== "fr" ? "grey" : "blue"}}
                                 onClick={() => setGameday("fr")}/>
                <DHButtonDefault label="Sa"
                                 style={{backgroundColor: gameday !== "sa" ? "grey" : "blue"}}
                                 onClick={() => setGameday("sa")}/>
                <DHButtonDefault label="So"
                                 style={{backgroundColor: gameday !== "so" ? "grey" : "blue"}}
                                 onClick={() => setGameday("so")}/>
                <DHButtonDefault label="Löschen"
                             onClick={() => {
                                    setGameday(undefined);
                                    setGamezeitpunkt(undefined);
                                 }}/>
            </div>
        </div>
    }

    const getDataArea = () => {
        return <div style={{padding: 20}}>
            <ErrorInfoComponent infoMessage={infoMessage} errorMessage={errorMessage} onClearInfoMessage={() => setInfoMessage(undefined)}
                                onClearErrorMessage={() => setErrorMessage(undefined)}/>
            <div>{"Einstellungen zur Mannschaft '" + bezeichnung + "' verwalten."}</div>
            {getWeekdaysArea()}
            <div style={{marginTop:20}}>
                <DHTimePicker label="Startzeitpunkt"
                              disabled={gameday === undefined}
                              value={gamezeitpunkt} changeValue={(value) => setGamezeitpunkt(value)}/>
            </div>
            <hr/>
        </div>
    }

    return <DHDialog onClose={() => onClose()} title="Mannschafteinstellungen verwalten" show={true}
                     showCloseButton={true}
                     buttons={getButtons()} comp={getDataArea()}/>
}
